import { makeStyles } from '@material-ui/core';
import { theme } from '../../constants/theme';

const useTestBedConfigureStyles = () => {
  const useStyles = makeStyles({
    textAreaSize: {
      width: '100%'
    },
    flexBorder: {
      border: '1px solid grey',
      margin: '20px 75px',
      borderRadius: '10px',
      paddingTop: '9px'
    },
    gridColumns: {
      display: 'flex',
      justifyContent: 'center'
    },
    flexContainerBottom: {
      display: 'flex',
      justifyContent: 'center',
      borderTop: '1px solid grey',
      borderBottom: '1px solid grey',
      padding: '10px'
    },
    ButtonClass: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-end',
      width: '100%'
    },
    labelColumns: {
      display: 'flex',
      justifyContent: 'start',
      paddingLeft: '60px',
      paddingBottom: '10px'
    },
    subLable: {
      fontWeight: '600 !important',
      fontSize: '14px !important',
      width: '100%',
      marginTop: '5px',
      marginBottom: '5px !important'
    },
    flexContainer: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      borderBottom: '1px solid grey'
    },
    versionText: {
      fontSize: '12px',
      fontWeight: 'bold'
    },
    tabTitleRow: {
      marginBottom: '8px',
      paddingBottom: '10px',
      borderBottom: `2px solid ${theme.colors.special.cyan}`
    },
    tabContainer: {
      display: 'flex',
      border: `1px solid ${theme.colors.border.lightest}`,
      borderRadius: theme.borderRadius.xlarge,
      overflow: 'hidden',
      margin: '20px 0',
      minHeight: '300px',
      backgroundColor: theme.colors.white,
      '@media (max-width: 768px)': {
        flexDirection: 'column',
        minHeight: '200px'
      }
    },
    tabNavigation: {
      width: '250px',
      backgroundColor: theme.colors.legacy.bgGrayMedium,
      borderRight: `1px solid ${theme.colors.border.lightest}`,
      display: 'flex',
      flexDirection: 'column',
      '@media (max-width: 768px)': {
        width: '100%',
        flexDirection: 'row',
        borderRight: 'none',
        borderBottom: `1px solid ${theme.colors.border.lightest}`,
        overflowX: 'auto'
      }
    },
    tabButton: {
      padding: '16px 20px',
      border: 'none',
      backgroundColor: 'transparent',
      cursor: 'pointer',
      textAlign: 'left',
      fontSize: theme.typography.fontSize.md,
      fontWeight: theme.typography.fontWeight.medium,
      color: theme.colors.border.hoverAlt,
      borderBottom: `1px solid ${theme.colors.border.lightest}`,
      transition: `all ${theme.transitions.slow} ease`,
      '&:hover': {
        backgroundColor: theme.colors.special.cyanLight,
        color: theme.colors.background.lighter
      },
      '@media (max-width: 768px)': {
        minWidth: '150px',
        textAlign: 'center',
        borderBottom: 'none',
        borderRight: `1px solid ${theme.colors.border.lightest}`,
        '&:last-child': {
          borderRight: 'none'
        }
      }
    },
    tabButtonActive: {
      backgroundColor: theme.colors.special.cyan,
      color: theme.colors.white,
      fontWeight: theme.typography.fontWeight.semibold,
      '&:hover': {
        backgroundColor: theme.colors.special.cyanDark,
        color: theme.colors.white
      }
    },
    tabContent: {
      flex: 1,
      padding: '24px',
      backgroundColor: theme.colors.white
    },
    tabTitle: {
      fontSize: '18px',
      fontWeight: '600',
      color: '#333',
      margin: 0
    },
    checkboxSection: {
      '& .MuiFormGroup-root': {
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap',
        gap: '8px 20px',
        alignItems: 'flex-start'
      },
      '& .MuiFormControlLabel-root': {
        margin: '2px 0',
        alignItems: 'center',
        display: 'flex',
        flex: '0 1 auto',
        minWidth: 'max-content',
        '& .MuiFormControlLabel-label': {
          fontSize: '14px',
          color: '#333',
          whiteSpace: 'nowrap'
        },
        '& .MuiCheckbox-root': {
          padding: '4px 8px 4px 4px'
        }
      }
    },
    formSection: {
      justifyContent: 'center'
    },
    configInput: {
      minWidth: '45%'
    },
    graphOption: {
      display: 'block',
      padding: '8px 16px'
    },
    graphId: {
      wordBreak: 'break-all'
    },
    formRowBox: {
      display: 'flex',
      justifyContent: 'space-between',
      padding: '0px 32px'
    },
    tabPaddingBox: {
      padding: '0px 32px'
    },
    jsonConfigSection: {
      marginTop: '20px'
    },
    welcomeMessageBox: {
      display: 'flex',
      flexDirection: 'column',
      padding: '0px 32px'
    },
    launchButton: {
      background: '#1A202C' // Keep this as is - appears to be a specific app color
    },
    autocompleteListbox: {
      maxHeight: 250,
      overflowX: 'auto',
      whiteSpace: 'nowrap',
      width: 'auto',
      minWidth: 400
    },
    formControl: {
      width: '45%',
      marginTop: '8px !important'
    },
    headerTitle: {
      padding: '8px'
    }
  });

  return useStyles();
};

export default useTestBedConfigureStyles;
